<template>
  <v-container
    id="regular-tables-view"
    fluid
    tag="section"
  >
    <material-card
      icon="mdi-format-list-numbered-rtl"
      icon-small
      title="اعضایی که جدید به لیست اضافه شده اند"
      color="accent"
      :loading="loading"
    >
      <v-row>
        <v-col
          cols="12"
          style="padding:0 40px 40px"
        >
          <v-row>
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="اطلاعات مورد نظر خود جهت جستجو وارد کنید"
                single-line
                hide-details
                class="mb-5"
              />
            </v-col>
            <v-col cols="12">
              <v-data-table
                :headers="headers"
                :items="items"
                :items-per-page="500"
                :search="search"
                class="elevation-1"
              >
                <template v-slot:item="row">
                  <tr>
                    <td>
                      {{ row.item.firstName }}
                    </td>
                    <td>
                      {{ row.item.lastName }}
                    </td>
                    <td>
                      {{ row.item.personalCode }}
                    </td>
                    <td>
                      {{ row.item.nationalCode }}
                    </td>
                    <td>
                      {{ row.item.agentCode }}
                    </td>
                    <td>
                      {{ row.item.agentTitle }}
                    </td>
                    <td />
                    <td>
                      {{ row.item.hoghoghiUnit }}
                    </td>
                    <td>
                      {{ row.item.officeUnit }}
                    </td>
                    <td>
                      {{ row.item.mobile }}
                    </td>
                    <td class="text-center">
                      {{ row.item.totalSavedMoney.toString().toPriceFormat() }}
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </material-card>
    <confirm-dlg ref="confirm" />
    <div class="py-3" />
  </v-container>
</template>

<script>
  import api from '@/util/app-api'
  import toast from '@/util/toast'

  export default {
    name: 'CheckoutThisMonth',
    components: {
      ConfirmDlg: () => import('@/components/Confirm'),
    },
    data () {
      return {
        errorMessages: '',
        search: '',
        loading: false,
        headers: [
          {
            text: 'نام',
            align: 'start',
            sortable: true,
            value: 'firstName',
          }, {
            text: 'نام خانوادگی',
            align: 'start',
            sortable: true,
            value: 'lastName',
          }, {
            text: 'کد پرسنلی',
            align: 'center',
            sortable: true,
            value: 'personalCode',
          }, {
            text: 'کد ملی',
            align: 'center',
            sortable: true,
            value: 'nationalCode',
          }, {
            text: 'کد عامل',
            align: 'center',
            sortable: true,
            value: 'agentCode',
          }, {
            text: 'عنوان عامل',
            align: 'center',
            sortable: true,
            value: 'agentTitle',
          }, {
            text: 'جنسیت',
            align: 'center',
            sortable: true,
            value: 'gender',
          }, {
            text: 'واحد حقوقی',
            align: 'start',
            sortable: true,
            value: 'hoghoghiUnit',
          }, {
            text: 'واحد اداری',
            align: 'start',
            sortable: true,
            value: 'officeUnit',
          }, {
            text: 'موبایل',
            align: 'start',
            sortable: true,
            value: 'mobile',
          }, {
            text: 'پس انداز',
            align: 'start',
            sortable: true,
            value: 'totalSavedMoney',
          },
        ],
        items: [],
      }
    },
    mounted () {
      this.loadData()
    },
    methods: {
      loadData () {
        this.loading = true
        api.get('admin/report/Members', null)
          .then(
            response => {
              this.items = response
            })
          .catch(err => {
            toast.error(err.message)
          })
          .finally(x => { this.loading = false })
      },
    },
  }
</script>
<style>
</style>
